import { default as React } from 'react'
import { Member, User } from '@citruscamps/citrus-client'
import { DefaultErrorView } from './DefaultErrorView'

export interface IErrorViewProps extends Omit<IErrorBoundryProps, 'ErrorView'> {
  error?: any
  errorInfo?: any
}

interface IState {
  error: any
  errorInfo: any
}

export interface IErrorBoundryProps {
  user?: User
  member?: Member
  children?: React.ReactNode
  ErrorView?: (props: IErrorViewProps) => React.ReactElement
}

export class ErrorBoundary extends React.Component<IErrorBoundryProps, IState> {
  constructor(props: IErrorBoundryProps) {
    super(props)
    this.state = { error: null, errorInfo: null }
  }

  componentDidCatch(error: any, errorInfo: any) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      errorInfo,
    })
    // You can also log error messages to an error reporting service here
  }

  render(): React.JSX.Element {
    if (this.state.errorInfo) {
      const { ErrorView, ...errorProps } = this.props
      if (!!ErrorView) {
        return <ErrorView {...errorProps} {...this.state} />
      }
      // Error path
      return <DefaultErrorView {...errorProps} {...this.state} />
    }
    // Normally, just render children
    return <>{this.props.children}</>
  }
}
